import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';
// 引入重置样式
import './assets/styles/reset.scss';
import './assets/styles/yellow-pages.scss';
import './assets/styles/yellow-home.scss';
import './assets/styles/yellow-cases.scss';
import './assets/styles/yellow-majors.scss';
import './assets/styles/yellow-scholarships.scss';
import './assets/styles/yellow-universities.scss';
import './assets/styles/yellow-account.scss';

// Element Plus 样式（按需引入时只需要引入基础样式）
import 'element-plus/dist/index.css';

const app = createApp(App);

// 注册 Pinia
const pinia = createPinia();
app.use(pinia);

// 注册路由
app.use(router);

// Element Plus 组件和 API 已通过 unplugin-vue-components 和 unplugin-auto-import 自动导入
// 无需手动注册，直接使用即可

app.mount('#app');
